var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isElcEmployee)?_c('ElcEmployee'):(_vm.isStarBucksEmployee)?_c('StarbucksEmployee',{attrs:{"employeeInfo":_vm.employeeInfo}}):_c('Common')
}
var staticRenderFns = []

export { render, staticRenderFns }